import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { offsetTimezone } from '../../../services/utils';

const DateCell = ( { date } ) => {
	return (
		<span>{ offsetTimezone( date, 'date' ) }</span>
	);
};

DateCell.propTypes = { date: PropTypes.string.isRequired };

export default memo( DateCell );
